import { Component, OnInit } from '@angular/core';
import { MainService } from 'src/app/services/main-service.service';
import { HttpClient } from '@angular/common/http';
import { ProposalService } from 'src/app/services/proposal/proposal.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CommonModule, DatePipe } from '@angular/common';
import { environment } from '../../../environments/environment';
import * as moment from "moment-timezone";
import { ToasterService } from 'src/app/services/toaster.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
  standalone:true,
  imports:[CommonModule, FormsModule]
})
export class CallbackComponent implements OnInit {
  public data;
  planInfo: any;
  mask: any = [/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  messageDesc: any;
  priority: any;
  response: any = '';
  payment_process_data: any;
  constructor(
    public modalRef: BsModalRef,
    public proposal: ProposalService,
    public http: HttpClient,
    public mainService: MainService,
    public datePipe: DatePipe,
    private _toaster: ToasterService
  ) { }

  ngOnInit() {
    this.getTimeZoneName();
    if (localStorage.getItem('payment_process_data')) {
      this.payment_process_data = JSON.parse(localStorage.getItem('payment_process_data'));
      this.payment_process_data.name = this.payment_process_data.name ? this.payment_process_data.name : '';
      this.payment_process_data.patient_email = this.payment_process_data.patient_email ? this.payment_process_data.patient_email : '';
      if (this.payment_process_data.patient_mobile && this.payment_process_data.patient_mobile.split('-').length > 1) {
        this.payment_process_data.patient_mobile = this.payment_process_data.patient_mobile.split('-')[1]
      }
    } else if(localStorage.getItem('pay_recurring_data')){
      this.payment_process_data = JSON.parse(localStorage.getItem('pay_recurring_data'));
      this.payment_process_data.name = this.payment_process_data.title?(this.payment_process_data.title+" "+this.payment_process_data.patient_first_name+" "+this.payment_process_data.patient_last_name):(this.payment_process_data.patient_first_name+" "+this.payment_process_data.patient_last_name)
      this.payment_process_data.patient_email = this.payment_process_data.patient_email ? this.payment_process_data.patient_email : '';
      if (this.payment_process_data.patient_mobile && this.payment_process_data.patient_mobile.split('-').length > 1) {
        this.payment_process_data.patient_mobile = this.payment_process_data.patient_mobile.split('-')[1]
      }
    } else {
      this.payment_process_data = {};
    }   
    this.planInfo = this.data;
    this.planInfo.patient_name = this.planInfo.patient_first_name ? this.planInfo.patient_first_name + ' ' + (this.planInfo.patient_last_name ? this.planInfo.patient_last_name: '') : '';
    if (this.planInfo.patient_mobile && this.planInfo.patient_mobile.split('-').length > 1) {
      this.planInfo.patient_mobile = this.planInfo.patient_mobile.split('-')[1];
    }
  }

  callbackReq(form: any) {
    if (!this.messageDesc || !this.messageDesc.trim()) {
      this._toaster.message('Please enter a valid message', 2);
      return;
    }
    let date = new Date();
    let params = {
      request_source: 1,
      user_type: 2,
      name: this.planInfo.patient_name || this.payment_process_data.name,
      doctor_mobile: this.planInfo.patient_mobile ? this.planInfo.patient_mobile : this.payment_process_data.patient_mobile ? this.payment_process_data.patient_mobile : '',
      message: this.messageDesc.trim(),
      call_req_date: this.datePipe.transform(date, 'yyyy/MM/dd'),
      call_req_time: this.datePipe.transform(date.setHours(date.getHours() + 1), 'hh:mm'),
      csr_req_tz: this.getTimeZone(),
      csr_req_tz_name: this.getTimeZoneName(),
      priority: this.priority,
      reason_id: 32,
      requested_email: this.planInfo.patient_email ? this.planInfo.patient_email : this.payment_process_data.patient_email ? this.payment_process_data.patient_email : '',
      doctor_mobile_country_code : this.planInfo.patient_mobile_country_code ? this.planInfo.patient_mobile_country_code : this.payment_process_data.patient_mobile_country_code ? this.payment_process_data.patient_mobile_country_code : '',
      country_id: this.mainService.defaultCountry['country_id'] || this.planInfo.country_id
    };
    if (form.invalid) {
      return false;
    }
    this.mainService.setLoader(true);
    this.http.post(environment.request_url + 'new_callback_request_website', params)
      .subscribe((data: any) => {
        this.mainService.setLoader(false);
        if(data && data.is_error){
          this.response = '';
          this._toaster.message(data.err, 3);
        } else {
          this.response = data;
        }
      }, (error: any) => {
        this.mainService.setLoader(false);
        this.response = '';
      })
  }

  getTimeZone() {
    let timeZone = "";
    let time = new Date().getTimezoneOffset();
    let hours = Math.abs(Math.trunc(time / 60));
    let minutes = ("0" + time % 60).slice(-2);
    if (time > 0) {
      timeZone = "-" + hours + minutes;
    } else {
      timeZone = "+" + hours + minutes;
    }
    return timeZone;
  }

  getTimeZoneName() {
    let zone_name = moment.tz.guess();
    return moment.tz(zone_name).zoneAbbr()
  }

}
